import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const CheckboxSpan = styled.span({
  fontSize: tokens.fontSize[1],
  textTransform: 'none',
  color: tokens.color.airJordan[600]
})

export const CheckIcon = styled.div<{ large: boolean }>(({ large }) => ({
  width: large ? '1.25rem' : '1rem',
  height: large ? '1.25rem' : '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  borderRadius: tokens.borderRadius.s,
  border: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan.p}`,
  flexShrink: 0,

  svg: {
    display: 'none'
  }
}))

export const CheckboxInput = styled.input()
export const Graphic = styled.g()

export const CheckboxLabel = styled.label<{
  textAlign?: 'left' | 'right'
  inverted?: boolean
  centeredIcon?: boolean
}>(({ textAlign, inverted, centeredIcon = false }) => ({
  ...(inverted && {
    [`${CheckIcon}`]: {
      borderColor: tokens.color.yeezy[0]
    }
  }),

  ...(centeredIcon && {
    [`& > ${CheckIcon}`]: {
      alignSelf: 'center'
    }
  }),

  // Label styles
  display: 'flex',
  backgroundColor: 'transparent',
  marginBottom: 0,
  marginLeft: 0,
  padding: 0,
  flexDirection: textAlign === 'left' ? 'row-reverse' : 'row',

  // Span styles
  [`${CheckboxSpan}`]: {
    marginLeft: textAlign === 'left' ? '' : tokens.spacing[4],
    marginRight: textAlign === 'left' ? tokens.spacing[4] : '',
    lineHeight: tokens.lineHeight.body,
    color: inverted ? tokens.color.yeezy[0] : tokens.color.airJordan[600]
  },

  // Hover styles
  [`${CheckboxInput}:hover ~ ${CheckIcon}`]: {
    svg: {
      display: 'block'
    },

    [`${Graphic}`]: {
      fill: tokens.color.airJordan[400]
    }
  },

  // Checked styles
  [`${CheckboxInput}:checked ~ ${CheckIcon}`]: {
    backgroundColor: inverted
      ? tokens.color.yeezy[0]
      : tokens.color.airJordan.p,
    borderColor: inverted ? tokens.color.yeezy[0] : tokens.color.airJordan.p,
    pointerEvents: inverted ? 'none' : 'auto',

    svg: {
      display: 'block'
    },

    [`${Graphic}`]: {
      fill: inverted ? tokens.color.airJordan.p : tokens.color.yeezy[0]
    }
  },

  // Disabled styles
  [`${CheckboxInput}:disabled ~ ${CheckIcon}`]: {
    backgroundColor: tokens.color.airJordan[inverted ? 700 : 200],
    borderColor: tokens.color.airJordan[inverted ? 800 : 300]
  },

  [`${CheckboxInput}:disabled ~ ${CheckboxSpan}`]: {
    color: tokens.color.airJordan[500]
  },

  // Toggle styles
  [`${CheckboxInput}:checked`]: {
    [`& + ${CheckboxSpan}`]: {
      color: tokens.color.yeezy[0]
    }
  }
}))
